import {AnyLinkType} from 'shared/pretty-easy-navigation/models';

export const TrainerMenu: AnyLinkType[] = [
    {
        type: 'link',
        label: 'navigation.compass',
        link: '/boussole',
        icon: 'navigation-link__compass',
    },
    {
        type: 'linkGroup',
        label: 'navigation.contents',
        links: [
            {
                type: 'link',
                label: 'navigation.collections',
                link: '/further/les-collections',
                icon: 'navigation-link__collections',
            },
            {
                type: 'link',
                label: 'navigation.lessons',
                link: '/lessons/list',
                icon: 'navigation-link__lessons',
            },
            {
                type: 'accordionLinkGroup',
                label: 'navigation.corpus_group',
                icon: 'navigation-group__corpus',
                links: [
                    {
                        type: 'link',
                        label: 'navigation.corpus_global',
                        link: '/corpus/11057',
                        icon: 'navigation-link__list-item',
                    },
                    {
                        type: 'link',
                        label: 'navigation.corpus_user',
                        link: '{{USER_CORPUS_LINK}}',
                        icon: 'navigation-link__list-item',
                    },
                ],
            },
        ],
    },
    {
        type: 'linkGroup',
        label: 'navigation.monitoring_group',
        links: [
            {
                type: 'accordionLinkGroup',
                label: 'navigation.learner_management_group',
                icon: 'navigation-group__my-learners',
                links: [
                    {
                        type: 'link',
                        label: 'navigation.groups_management',
                        link: '/groups/list/groups',
                        icon: 'navigation-link__list-item',
                    },
                    {
                        type: 'link',
                        label: 'navigation.workgroups_management',
                        link: '/groups/list/workgroups',
                        icon: 'navigation-link__list-item',
                    },
                    {
                        type: 'link',
                        label: 'navigation.learners_management',
                        link: '/groups/list/learners',
                        icon: 'navigation-link__list-item',
                    },
                    {
                        type: 'link',
                        label: 'navigation.self_assignments',
                        link: '/followed/tab/self',
                        icon: 'navigation-link__list-item',
                    },
                ],
            },
        ]
    },
    {
        type: 'linkGroup',
        label: 'navigation.tools',
        links: [
            {
                type: 'link',
                label: 'navigation.notepad',
                link: '/notepad/list',
                icon: 'navigation-link__notepad',
            },
            {
                type: 'link',
                label: 'navigation.mindmap',
                link: '/mindmap/list',
                icon: 'navigation-link__mindmap',
            },
        ]
    },
    {
        type: 'linkGroup',
        links: [
            {
                type: 'link',
                label: 'navigation.legal_notice',
                link: '/informations-legales',
                icon: 'navigation-link__legal-notice',
            },
            {
                type: 'link',
                label: 'navigation.contact',
                link: '{{GAR_CONTACT}}',
                icon: 'navigation-link__contact',
            },
            {
                type: 'link',
                label: 'navigation.site_map',
                link: '{{SITE_MAP_LINK}}',
                icon: 'navigation-link__sitemap',
            },
        ],
    },
];
